<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.material.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="material.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.material.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="material.name" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.material.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.material.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="material.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.material.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import MaterialRepository from '@/repositories/tuevs/MaterialRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      material: 'tuevs/material/current',
      isLoading: 'tuevs/material/isLoading'
    }),
    pageTitle() {
      if (this.material_id) return this.$t('tuevs.material.form.titulo_pagina.editar')
      return this.$t('tuevs.material.form.titulo_pagina.criar')
    }
  },
  data() {
    return {
      material_id: null
    }
  },
  methods: {
    ...mapActions([
      'tuevs/material/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      MaterialRepository.post(this.material).then(() => {
        this.$snotify.success(this.$t('tuevs.material.form.create.success'))
        this.$router.push({name: 'tuevs.material'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.material.form.create.error'))
        if (error.response.status === 422) {
          MaterialRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      MaterialRepository.put(this.material_id, this.material).then(() => {
        this.$snotify.success(this.$t('tuevs.material.form.update.success'))
        this.$router.push({name: 'tuevs.material'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.material.form.update.error'))
        if (error.response.status === 422) {
          MaterialRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('tuevs/material/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.material_id = this.$route.params.id
      await this['tuevs/material/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
